import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const RectangleBlink = (props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  // Blinken auswerten
  let blink = false;
  try {
    if (props.element.blinkFreq) {
      blink = true;
    }
  } catch {
    blink = false;
  }

  // Blinkfrequenz auswerten (Hz → Interval in ms)
  let blinkFreq = 1;
  try {
    blinkFreq = props.element.blinkFreq || 1;
  } catch {
    blinkFreq = 1;
  }

  //========================================================================
  // Auswerten, ob Aktiv
  let simulation = false;
  try {
    simulation = props.style.properties.simulation;
  } catch (error) {
    simulation = false;
  }

  let isActive = value.value === "1" || simulation;

  //========================================================================
  // Blink-State
  const [show, setShow] = useState(true);

  useEffect(() => {
    let intervalId;

    if (isActive && blink) {
      // ms pro Umschaltung (ein/aus)
      const interval = 1000 / (blinkFreq * 2);
      intervalId = setInterval(() => {
        setShow((prev) => !prev);
      }, interval);
    } else {
      setShow(true); // sicherstellen, dass sichtbar wenn kein Blinken
    }

    return () => clearInterval(intervalId);
  }, [isActive, blink, blinkFreq]);

  //========================================================================
  // Border-Berechnung
  let borderWidth;
  if (props.style.borderWidth === "NaNpx") {
    borderWidth = "0px";
  } else {
    borderWidth = props.style.borderWidth;
  }
  const left = `calc(${props.style.left} - ${borderWidth})`;
  const top = `calc(${props.style.top} - ${borderWidth})`;
  const right = `calc(${props.style.right} - ${borderWidth})`;
  const bottom = `calc(${props.style.bottom} - ${borderWidth})`;

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        backgroundColor:
          isActive && show
            ? props.element.activeColor
            : props.style.backgroundColor || "#333",
        visibility: props.props.visibility,
        position: "absolute",
        left: left,
        top: top,
        right: right,
        bottom: bottom,
        borderWidth: borderWidth,
      }}
      title={
        props.element.tooltip
          ? language.displayText(props.element.tooltip) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "")
          : language.displayText(value.name) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "") +
            (globalVars.cyclicUpdate || globalVars.editor
              ? "\n" + ("Variable: " + props.props.variable)
              : "")
      }
    ></div>
  );
};

export default observer(RectangleBlink);
